export interface PolicyFilterOption {
    id: string;
    name: string;
}

interface PolicyFilterLabelParams {
    templateId: string;
    policies: readonly PolicyFilterOption[];
}

export function toSortedPolicyFilterOptions(
    templates: readonly PolicyFilterOption[],
): PolicyFilterOption[] {
    return templates
        .map(({ id, name }) => ({ id, name }))
        .sort((left, right) => left.name.localeCompare(right.name));
}

export function resolvePolicyFilterLabel({
    templateId,
    policies,
}: PolicyFilterLabelParams): string {
    const policy = policies.find(({ id }) => id === templateId);
    if (policy) {
        return policy.name;
    }
    return policies.length > 0 ? "Deleted policy" : "Policy";
}

export function scopedTemplateIdFor(
    templateIds: readonly string[],
): string | null {
    return templateIds.length === 1 ? templateIds[0] : null;
}
